import type { ComponentPropsWithRef } from "react";
import { cn } from "@/utils/style.ts";

export type DefinitionListProps = ComponentPropsWithRef<"dl">;
export function DefinitionList({ children, className, ...props }: DefinitionListProps) {
    return (
        <dl {...props} className={cn("definition-list", className)}>
            {children}
        </dl>
    );
}

export type DefinitionTermProps = ComponentPropsWithRef<"dt">;
export function DefinitionTerm({ children, className, ...props }: DefinitionTermProps) {
    return (
        <dt {...props} className={cn("definition-list__term", className)}>
            {children}
        </dt>
    );
}

export type DefinitionDescriptionProps = ComponentPropsWithRef<"dd">;
export function DefinitionDescription({ children, className, ...props }: DefinitionDescriptionProps) {
    return (
        <dd {...props} className={cn("definition-list__description", className)}>
            {children}
        </dd>
    );
}
